import createFormSlice from '@/store/reducers/createFormSlice';
import { sendForm } from '@/core/utils/sendFormData';
import API_ENDPOINTS from '@/api/apiConfig';
import { createSlice } from '@reduxjs/toolkit';
import { addDomainFormTypes } from '@/store/types/addDomainFormTypes';
import { handleResponseError } from '@/core/utils/handleResponseError';
import { apiUrl } from '@/api/axios';

const addDomainFormData: addDomainFormTypes = {
	domain: '',
};

const addDomainSlice = createFormSlice('addDomainForm', addDomainFormData);

const combinedSlice = createSlice({
	name: 'addDomainForm',
	initialState: addDomainSlice.getInitialState(),
	reducers: {
		...addDomainSlice.caseReducers,
		checkDomainSuccess(state, action) {
			state.successMessage = 'Domain is valid and ready to be added.';
		},
	},
});

export const { resetSuccessMessage, setError, checkDomainSuccess } = combinedSlice.actions;

export const checkDomainBeforeAdd = (domain: string) => async (dispatch: any) => {
	try {
		const response = await apiUrl.get(`${API_ENDPOINTS.checkDomain}${domain}`);
		if (response.status === 200) {
			dispatch(checkDomainSuccess(domain));
			return true;
		} else {
			throw new Error('Domain validation failed');
		}
	} catch (error) {
		handleResponseError(error, (errorMessage) => dispatch(setError(errorMessage)));
		return false;
	}
};

export const sendDomain = (data: addDomainFormTypes) => async (dispatch: any) => {
	const isDomainValid = await dispatch(checkDomainBeforeAdd(data.domain));
	if (isDomainValid) {
		return dispatch(sendForm(combinedSlice, API_ENDPOINTS.postNewDomain, '')(data));
	}
};

export default combinedSlice.reducer;
export { combinedSlice as addDomainSlice };
